module.exports = __webpack_public_path__ + "img/equipos-moviles-img-11.6dac9cd4.jpg";